export const authRoleAccess = {
  themeExamples: ['Super Admin', 'user', 'Organization Admin'],
  dashborad: ['Super Admin', 'user', 'Organization Admin', 'District Officer', 'Case Officer', 'Case Manager', 'Organization Head', 'First Respondent', 'Director CID', 'Deputy Director', 'Department Head', 'OIC', 'Director NCPA', "Team Leader First Respondent", "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer"],
  //profile: ['Super Admin', 'user', 'Organization Admin','District Officer', 'Case Officer', 'Case Manager', 'Organization Head'],
  profile: ['Super Admin', 'user', 'Organization Admin', 'District Officer', 'Case Officer', 'Case Manager', 'Organization Head', 'Director CID', 'Deputy Director', 'Department Head', 'OIC', 'Director NCPA', "Team Leader First Respondent", "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer"],

  //organizations: ['Super Admin'],
  organizations_admins: ['Super Admin', 'Admin'],
  organizations_existing: ['Super Admin'],
  organizations_add: ['Super Admin'],
  organizations_management: ['Organization Admin'],
  case_category: ['Super Admin'],
  case_priority: ['Super Admin'],
  case_evidence_history: ['Organization Admin'],
  org_head_case_management: ['Organization Head'],
  case_officer_case_management: ['Case Officer', "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer", 'District Officer'],

  subcategory: ['Super Admin'],
  organizations: ['Super Admin', 'user'],
  manage_social_media: ['Super Admin'],
  support_type_creation: ['Super Admin'],
  manage_relationship: ['Super Admin'],
  suggest_designation: ['Organization Admin'],
  suggest_organization: ['Super Admin'],
  case_handle: ['Organization Admin'],
  case_questions_setup: ['Organization Admin'],
  national_case: ['Super Admin'],
  all_cases: ['Super Admin'],
  forwarded_cases: ['Super Admin'],
  case_manager_case_trasfer: ['Case Manager', "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer"],
  case_manager_cases: ['Case Manager', 'Director CID', 'Director NCPA', "Call Center Officer MoWCA", 'Organization Admin'],
  officer_case_reporting: ["Case Officer", 'District Officer'],

  victim_form: ["Victim Form"],
  officer_case_reporting: ["Case Officer", "First Respondent", "Call Center Officer MoWCA", "Team Leader First Respondent", 'District Officer', "Team Leader First Respondent"],
  data_setup: ["Super Admin"],
  reports: ["Super Admin", 'Organization Admin', 'District Officer', 'Case Officer', 'Case Manager', 'Organization Head', "Call Center Officer MoWCA",'Director CID', 'Deputy Director', 'Department Head', 'OIC', 'Director NCPA', "Legal Officer", "Counselling Officer"],

  case_officer_dashboard: ['Case Officer', 'District Officer'],
  case_manager_dashboard: ['Case Manager'],

  call_center_officer_dashboard: ['First Respondent'],
  call_center_manager_dashboard: ['Case Manager', "Team Leader First Respondent"],

  perpetrator_information: ['Case Officer', "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer", 'District Officer', "Team Leader First Respondent",'Director CID', 'Deputy Director', 'Department Head', 'OIC', 'Director NCPA'],

  first_respondent_case_view: ['First Respondent'],
  first_respondent_lead_case_view: ['Team Leader First Respondent'],

  //director_cid_national_inbox: ["Director CID"],
  manager_levels_access: ['Deputy Director', 'Department Head', 'OIC'],
  case_closure_approvals: ['Director CID', 'Director NCPA'],
  transfer_approvals: ['Director CID', 'Director NCPA'],

  information_search_view: ['Super Admin', 'Case Officer', 'District Officer', 'Case Manager', 'Organization Head', 'First Respondent', 'Director CID', 'Deputy Director', 'Department Head', 'OIC', 'Director NCPA', "Team Leader First Respondent", "Call Center Officer MoWCA", "Legal Officer", "Counselling Officer"],

  call_center_officer_mowca: ["Call Center Officer MoWCA", "Legal Officer", "Counselling Officer"],


}